import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "big-root" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  class: "svg"
}
const _hoisted_3 = {
  id: "庄_闲对_庄对_和",
  "data-name": "庄、闲对、庄对、和",
  transform: "translate(3.313 0.554)"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("circle", {
  cx: "9.5",
  cy: "9.5",
  r: "9.5",
  stroke: "none"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  id: "Ellipse_4",
  "data-name": "Ellipse 4",
  transform: "translate(8.687 11.446)",
  fill: "blue",
  stroke: "#fff",
  "stroke-width": "2"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("circle", {
  cx: "3.5",
  cy: "3.5",
  r: "3.5",
  stroke: "none"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("circle", {
  cx: "3.5",
  cy: "3.5",
  r: "3",
  fill: "none"
}, null, -1)
const _hoisted_8 = {
  key: 1,
  id: "Ellipse_22",
  "data-name": "Ellipse 22",
  transform: "translate(-3.313 -0.554)",
  fill: "red",
  stroke: "#fff",
  "stroke-width": "2"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("circle", {
  cx: "3.5",
  cy: "3.5",
  r: "3.5",
  stroke: "none"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("circle", {
  cx: "3.5",
  cy: "3.5",
  r: "3",
  fill: "none"
}, null, -1)
const _hoisted_11 = {
  key: 2,
  id: "Line_2",
  "data-name": "Line 2",
  y1: "9",
  x2: "9",
  transform: "translate(5.188 7.946)",
  fill: "none",
  stroke: "green",
  "stroke-linecap": "round",
  "stroke-width": "2"
}
const _hoisted_12 = {
  key: 0,
  id: "_2",
  "data-name": "2",
  x: "50%",
  y: "50%",
  "dominant-baseline": "middle",
  "text-anchor": "middle",
  fill: "green",
  "font-size": "12",
  "font-family": "PingFang SC Regular, PingFang SC"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock("svg", _hoisted_2, [
      _createVNode("g", _hoisted_3, [
        _createVNode("g", {
          id: "Op_component_2",
          "data-name": "Op component 2",
          transform: "translate(-3.313 -0.554)",
          fill: "none",
          stroke: _ctx.mdata.type === 0 ? 'red' : 'blue',
          "stroke-width": "2"
        }, [
          _hoisted_4,
          _createVNode("circle", {
            cx: "9.5",
            cy: "9.5",
            r: "8.5",
            fill: _ctx.mdata.isSuper6 ? 'red' : 'none'
          }, null, 8, ["fill"])
        ], 8, ["stroke"]),
        (_ctx.mdata.pair === 2 || _ctx.mdata.pair === 3)
          ? (_openBlock(), _createBlock("g", _hoisted_5, [
              _hoisted_6,
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        (_ctx.mdata.pair === 1 || _ctx.mdata.pair === 3)
          ? (_openBlock(), _createBlock("g", _hoisted_8, [
              _hoisted_9,
              _hoisted_10
            ]))
          : _createCommentVNode("", true),
        (_ctx.mdata.hasTie)
          ? (_openBlock(), _createBlock("line", _hoisted_11))
          : _createCommentVNode("", true)
      ]),
      (_ctx.mdata.tieSize > 0)
        ? (_openBlock(), _createBlock("text", _hoisted_12, _toDisplayString(_ctx.mdata.tieSize), 1))
        : _createCommentVNode("", true)
    ]))
  ]))
}